/**
 * Контент справки для страницы прицепов.
 * Используется в панели справки HelpPanel.
 */
export default {
  // Идентификатор страницы
  pageKey: 'trailers',

  // Ключ локализации заголовка страницы
  titleKey: 'help.pages.trailers.title',

  // Ключ локализации описания страницы
  overviewKey: 'help.pages.trailers.overview',

  // Идентификатор связанного тура
  tourId: 'trailers-page',

  // FAQ - часто задаваемые вопросы
  faq: [
    {
      id: 'add-trailer',
      questionKey: 'help.pages.trailers.faq.addTrailer.question',
      answerKey: 'help.pages.trailers.faq.addTrailer.answer',
    },
    {
      id: 'assign-device',
      questionKey: 'help.pages.trailers.faq.assignDevice.question',
      answerKey: 'help.pages.trailers.faq.assignDevice.answer',
    },
    {
      id: 'trailer-types',
      questionKey: 'help.pages.trailers.faq.trailerTypes.question',
      answerKey: 'help.pages.trailers.faq.trailerTypes.answer',
    },
    {
      id: 'trailer-specs',
      questionKey: 'help.pages.trailers.faq.trailerSpecs.question',
      answerKey: 'help.pages.trailers.faq.trailerSpecs.answer',
    },
    {
      id: 'view-history',
      questionKey: 'help.pages.trailers.faq.viewHistory.question',
      answerKey: 'help.pages.trailers.faq.viewHistory.answer',
    },
  ],

  // Контекстные подсказки для элементов страницы
  tooltips: {
    addButton: 'help.tooltips.trailers.addButton',
    search: 'help.tooltips.trailers.search',
    statusFilter: 'help.tooltips.trailers.statusFilter',
    trailerCard: 'help.tooltips.trailers.trailerCard',
    assignDevice: 'help.tooltips.trailers.assignDevice',
  },

  // Связанные туры (для раздела "Другие обзоры")
  relatedTours: ['devices-page', 'drivers-page', 'reports-page'],
}
